//TODO: Implement that cool starfield parallax thing we had before
